export default "__VITE_ASSET__RFZ4cqcD__"